module.exports = __webpack_public_path__ + "img/stayingalive.ef699e2f.png";